<template>
  <router-link class="company-news-list-item"
               :to="{ name: 'ArticleDetail', params: { id: item.id } }"
  >
    <div class="item-info">
      <cover class="cover"
             :cover="item.thumb"
             :alt="item.title"
      />
      <div class="info">
        <h4 class="title ym-two-line-ellipsis">{{ item.title }}</h4>
        <div class="date">{{ item.publishedTime|formatTime('yyyy年MM月dd日') }}</div>
      </div>
    </div>
    <div class="item-content">
      <div class="content"
           v-html="item.content"
      ></div>
      <div class="more">阅读更多></div>
    </div>
  </router-link>
</template>

<script>
  import Cover from '@/components/ProductCover';

  export default {
    name: 'ArticleItem',
    components: {
      Cover,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  @import '~@/assets/styles/mixins.less';

  .company-news-list-item {
    display: block;
    padding: 0 @size-base;
    box-sizing: border-box;
    &:not(:last-child) {
      margin-bottom: @size-large;
    }
  }

  .item-info {
    padding-bottom: @size-base;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cover {
    margin-right: @size-base;
  }

  .info {
    flex: 1;
    overflow: hidden;
    height: @product-cover-height;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    line-height: 1.4;
  }

  .date {
    font-size: @font-size-small;
    color: @color-text-lighter;
    align-self: flex-end;
  }

  .item-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .content {
    color: @color-text-light;
    margin-bottom: @size-small;
    overflow: hidden;
    .multi-ellipsis(2);
    /deep/ img, /deep/ video {
      max-width: 100%;
    }
  }

  .more {
    align-self: flex-end;
    font-size: @font-size-small;
    color: @color-primary;
  }
</style>
